var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.156,
    height: 21.156,
    viewBox: "0 0 21.156 21.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M10.578,21.156A10.578,10.578,0,0,1,3.1,3.1a10.578,10.578,0,1,1,14.96,14.959A10.509,10.509,0,0,1,10.578,21.156Zm2.759-10.1c1.18,0,1.357,1.316,1.357,2.1v2.39a.11.11,0,0,0,.11.11H16.93a.11.11,0,0,0,.11-.11V12.417a4.191,4.191,0,0,0-.766-2.51A2.972,2.972,0,0,0,13.8,8.715a3.669,3.669,0,0,0-2.105.657.108.108,0,0,1-.061.019.111.111,0,0,1-.076-.031.108.108,0,0,1-.034-.079V8.825a.11.11,0,0,0-.11-.11H9.745a.11.11,0,0,0-.11.11V15.55a.11.11,0,0,0,.11.11h2.126a.11.11,0,0,0,.11-.11V13.16C11.981,12.376,12.157,11.061,13.337,11.061ZM5.129,8.715a.092.092,0,0,0-.092.092v6.76a.093.093,0,0,0,.092.093h2.16a.093.093,0,0,0,.093-.093V8.807a.093.093,0,0,0-.093-.092Zm.85-4.139a1.4,1.4,0,1,0,1.4,1.4A1.4,1.4,0,0,0,5.979,4.576Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.20bc5f073799edc9275d2945bf9bd1d9.svg";
export { ForwardRef as ReactComponent };